module.exports = __webpack_public_path__ + "static/media/UserTesting.com.28cd6f6d.png";